import postStructure from 'src/utils/dataStructure/structures/postStructure';
import userStructure from 'src/utils/dataStructure/structures/userStructure';
import groupStructure from 'src/utils/dataStructure/structures/groupStructure';
import enrichDataObject from 'src/utils/enrichDataObject';

/**
 * Generate a function enforcing a structure from rawData
 */
const undesirableValues = { undefined: true, null: true };

const enforceStructure = (structure) => {
  const FIELDS = Object.entries(structure);
  return function enforceStructure(rawData) {
    const structuredData = {};
    FIELDS.forEach(
      ([name, get]) => {
        const value = get(rawData);

        if (undesirableValues[value]) {
          return;
        }

        structuredData[name] = get(rawData);
      });
    return structuredData;
  };
};

// TODO: remove this when we use solaris endpoints
// note: users and groups the up-to-date values returned for the server
export const enforcePostStructure = (postData, users = [], groups = [],
  likes = {}, userLikes = [], isFollowing = false) => {
  const post = enforceStructure(postStructure)({
    ...postData,
    tags: postData.tags || [],
    entities: postData.entities || [],
    hasRated: userLikes.indexOf(postData.id.toString()) > -1,
    numRatings: likes[postData.id] || 0,
    isFollowing,
  });
  const postAuthorData = post.author
    || postData.authorId && { id: postData.authorId }
    || {};
  const author = enforceStructure(userStructure)({
    ...postAuthorData,
    ...(users.find(x => (x.userId || x.id) === postAuthorData.id) || {}),
  });
  const editAuthor = postData.editAuthor && enforceStructure(userStructure)({
    ...postData.editAuthor,
    ...(users.find(x => (x.userId || x.id) === postData.editAuthor.id) || {}),
  });
  const group = enforceStructure(groupStructure)(groups.find(x => x.groupId === post.group) || {});
  const mentionedUsersMap = users.reduce((userMap, user) => {
    userMap[user.userId] = { id: user.userId, username: user.username || '' };
    return userMap;
  }, {});

  return {
    ...enrichDataObject(post, mentionedUsersMap),
    author,
    editAuthor,
    group,
  };
};
